import { useNavigate, useLocation, matchPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routesMap } from "../routes/routesMap";

export function useLanguageSwitcher() {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();

    const switchLanguage = (newLang, currentRouteKey) => {
        const route = currentRouteKey ? routesMap[currentRouteKey] : routesMap.home;
        if (!route) return;

        // pattern della lingua attuale e dell'altra lingua
        const itPattern = route.path.it;
        const enPattern = route.path.en;

        // prova a fare il match esatto con entrambi (utile se l'utente ha forzato una lingua nell'URL)
        const match =
            matchPath({ path: itPattern, end: true }, location.pathname) ||
            matchPath({ path: enPattern, end: true }, location.pathname);

        // base path di destinazione nella nuova lingua
        let newPath = route.path[newLang];

        // sostituisci eventuali parametri dinamici (es. :name)
        if (match?.params) {
            for (const [param, value] of Object.entries(match.params)) {
                newPath = newPath.replace(`:${param}`, value);
            }
        }

        // cambia lingua + naviga
        i18n.changeLanguage(newLang);
        navigate(newPath);
    };

    return { switchLanguage };
}